module.exports = __webpack_public_path__ + "img/LI110363.0c393563.png";